import { render, staticRenderFns } from "./newDesign.vue?vue&type=template&id=3497cd8e&scoped=true"
import script from "./newDesign.vue?vue&type=script&lang=js"
export * from "./newDesign.vue?vue&type=script&lang=js"
import style0 from "./newDesign.vue?vue&type=style&index=0&id=3497cd8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3497cd8e",
  null
  
)

export default component.exports